import { newCheckout, newYearlyCheckout } from "../../Stripe/StripeFunctions"
import "./NonSubscriberProfile.css"


export default function NonSubscriberProfile(){

    
    return (
        <div className="add-subscription-container">

            <div className="monthly-subscription subscription-option">

                <div className="price-text-container">
                    <div className="price-text"> $30  </div>  
                    <div className="slash"> / </div>
                    <div className="time-text"> Month </div>
                </div>

                <ul className="subscription-benefits">
                    <li>10,000 Code Submissions Per-Month</li>
                    <li> Ulimited MCQ & Written Attempts </li>
                    <li>$10 Billed Montly</li>
                </ul>

                <button className="subscribe-button" onClick={newCheckout}>
                    Subsribe Now 
                </button>

            </div>

            <div className="yearly-subscription subscription-option">

                <div className="price-text-container">
                    <div className="price-text"> $150  </div>   
                    <div className="slash"> / </div>
                    <div className="time-text"> Year </div>
                </div>

                <ul className="subscription-benefits">
                    <li>10,000 Code Submissions Per-Month</li>
                    <li> Ulimited MCQ & Written Attempts </li>
                    <li>$50 Billed Yearly</li>
                    <li>Save $210 Per-Year vs Monthly</li>
                </ul>

                <button className="subscribe-button" onClick={newYearlyCheckout}>
                    Subsribe Now 
                </button>
            </div>     

        </div>
    )
}